<template>
    <div class="step-member">
        <el-form :inline="true" :model="formSearch" class="form-member-query" size="mini" ref="searchForm">
            <el-form-item :label="$t('c.userInfo')">
                <el-input v-model="formSearch.search" :placeholder="$t('tip.userSearch')"
                          @keyup.enter.native="!memberLoading && queryMembers()" clearable></el-input>
            </el-form-item>

            <select-multiple :nameArrays="selectNames"
                             v-on:getGroupTypeVal="getGroupTypeVal"
                             v-on:getPositionTypeVal="getPositionTypeVal"
                             v-on:getForLevelVal="getForLevelVal"
            >
            </select-multiple>
            <select-multi-orgs @orgsChange="orgsChange"></select-multi-orgs>
            <el-form-item>
                <advanced-filter @advancedChange="advancedChange" ref="advancedFilter"></advanced-filter>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="queryMembers" :disabled="tabIndex == 1 || memberLoading">
                    {{ $t('c.query') }}
                </el-button>
            </el-form-item>
        </el-form>
        <el-tabs type="border-card" @tab-click="changeTab">
            <el-tab-pane>
                        <span slot="label" class="member-tab">
                            <el-popover
                                placement="top"
                                width="auto"
                                trigger="hover"
                                v-model="checkAllPopover">
                                <p style="margin-bottom:10px;word-break: break-all">{{ $t('train.checkAllMembers') }}</p>
                                <div style="text-align: center; margin: 0">
                                    <el-button type="primary" size="mini"
                                               @click="checkAllMembers(true)">{{ $t('res.checkAll') }}</el-button>
                                    <el-button size="mini" type="warning"
                                               @click="checkAllMembers(false)">{{ $t('res.cancelCheckAll') }}</el-button>
                                </div>

                                <a class="check-btn" slot="reference">
                                    <i class="nucfont inuc-bars"></i>
                                </a>
                            </el-popover>
                             {{ $t('system.allMembers') }}
                        </span>

                <!-- 全部学员table -->
                <data-tables ref="traineeTable"
                             class="traineeTable"
                             :data="tableData"
                             :table-props="tableProps"
                             :current-page.sync="currentPage"
                             :page-size="20"
                             :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
                             @select="selectChange"
                             @select-all="selectAllChange"
                             v-loading="memberLoading"

                >
                    <el-table-column type="selection" :reserve-selection="true" width="55"
                                     align="center"></el-table-column>
                    <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label"
                                     :key="title.label"
                                     align="center"
                                     sortable="custom">
                    </el-table-column>
                </data-tables>
            </el-tab-pane>

            <el-tab-pane :label='selectTableNum'>
                <!-- 已选学员table -->
                <data-tables :data="multipleSelection"
                             :table-props="tableProps"
                             :page-size="20"
                             :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
                >
                    <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label"
                                     :key="title.label"
                                     align="center"
                                     sortable="custom">
                    </el-table-column>
                    <el-table-column :label="$t('c.operation')" align="center" min-width="20%">
                        <template slot-scope="scope">
                            <el-button
                                :title="$t('c.delete')"
                                size="mini"
                                class="el-icon-delete"
                                type="primary"
                                round
                                @click="delMember(scope.$index, scope.row.id)">
                            </el-button>
                        </template>
                    </el-table-column>
                </data-tables>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import AdvancedFilter from '@components/AdvancedFilter';
import api from "@/api";

export default {
    components: {
        AdvancedFilter
    },

    data() {
        return {
            // 第二步选择学员
            tabIndex: 0,
            tableData: [],
            tableProps: {
                border: false,
                stripe: true,
                rowKey: row => row.id,
                height: "420px",
            },
            titles: [
                {
                    prop: 'name',
                    label: this.$t('c.username')
                }, {
                    prop: 'jobNo',
                    label: this.$t('c.idNo')
                }, {
                    prop: 'accountNo',
                    label: this.$t('c.account')
                }, {
                    prop: 'orgName',
                    label: this.$t('c.belong')
                }, {
                    prop: 'postName',
                    label: this.$t('c.position')
                }, {
                    prop: 'gradeName',
                    label: this.$t('c.grade')
                }
            ],
            currentPage: 1,
            selectNames: [
                {key: "groupType"},
                {key: "forLevel", title: `${this.$t('c.grade')}`},
                {key: "positionType"},
            ],
            formSearch: {
                search: '',
                orgIds: [],
                groupIds: [],
                gradeIds: [],
                postIds: [],
                advancedAccountNos: []
            },
            multipleSelection: [],
            checkAllPopover: false,
            memberLoading: false,
        }
    },

    computed: {
        selectTableNum() {
            return this.$t('system.selectedMember') + `(${this.multipleSelection.length})`;
        }
    },

    methods: {
        /**
         * 第二步相关
         * 更新左边数据到右边：通过select和selectAll
         * 更新右边数据到左边：updateSelectStatus
         * 右边的删除目前是单独更新
         */
        changeTab(tab, event) {
            this.tabIndex = tab.index;
        },
        // 左边table☑后，把值赋给右边已选中人员table
        selectChange(val) {
            this.multipleSelection = val;
        },
        selectAllChange(val) {
            this.multipleSelection = val;
        },
        updateSelectStatus() {
            let CheckboxElTable = this.$refs.traineeTable.$refs.elTable;

            this.$nextTick(() => {
                //CheckboxElTable.clearSelection();

                this.tableData.forEach(row => {
                    if (this.multipleSelection.find(v => v.userID == row.id || v.id == row.id)) {
                        CheckboxElTable.toggleRowSelection(row, true);
                    }
                });
            })

        },
        delMember(index, id) {
            let ind = this.multipleSelection.findIndex(v => v.id === id);

            /**
             * 不要直接用index删！使用id查出位置再删
             * 这样避免了快速点击会多次删除同一数据的bug
             */
            if (ind > -1) {
                this.multipleSelection.splice(ind, 1);
                let CheckboxElTable = this.$refs.traineeTable.$refs.elTable;
                let idx = this.tableData.findIndex(v => v.id === id);
                CheckboxElTable.toggleRowSelection(this.tableData[idx], false);
            }
        },
        queryMembers() {
            this.currentPage = 1;
            let queryData = {
                types: 3,
                ...this.formSearch
            };

            ['gradeIds', 'postIds'].forEach(v => {
                if (this.formSearch[v].includes(0)) {
                    delete queryData[v];
                }
            });

            this.memberLoading = true

            return api.queryTrainee(queryData).then((res) => {
                this.tableData = res.package;
                this.tableData.forEach(row => {
                    row.jobNo = row.jobNo || '--';
                    row.postName = row.postName || '--';
                    row.gradeName = row.gradeName || '--';
                })

                this.memberLoading = false
                //this.updateSelectStatus()
            }).catch(() => this.memberLoading = false)
        },

        fillData(data) {
            data.trainees.forEach(val => {
                if (val.userName) {
                    val.name = val.userName;
                    delete val.userName;
                }
                if (val.userID) {
                    val.id = val.userID;
                    delete val.userID;
                }

                this.multipleSelection.push(val);
            });
        },

        getData() {
            let data = []

            this.multipleSelection.forEach(val => {
                data.push({
                    userID: val.id || val.userID
                })
            });

            return data
        },

        clear() {
            this.multipleSelection = []
            let CheckboxElTable = this.$refs.traineeTable.$refs.elTable;
            CheckboxElTable.clearSelection();
        },

        // 20190131 xia 全选所有人员
        checkAllMembers(checkAll) {
            this.checkAllPopover = false;
            if (checkAll) {
                this.multipleSelection = [...this.tableData];
                this.$nextTick(() => {
                    let CheckboxElTable = this.$refs.traineeTable.$refs.elTable;
                    this.tableData.forEach(item => {
                        CheckboxElTable.toggleRowSelection(item, true);
                    })
                })
            } else {
                this.multipleSelection = [];
                this.$nextTick(() => {
                    let CheckboxElTable = this.$refs.traineeTable.$refs.elTable;
                    CheckboxElTable.clearSelection();
                })
            }
        },

        //搜索赋值
        orgsChange(data) {
            this.formSearch.orgIds = data;
        },
        advancedChange(data) {
            this.formSearch.advancedAccountNos = data;
        },
        getPositionTypeVal(data) {
            this.formSearch.postIds = data;
        },
        getGroupTypeVal(data) {
            this.formSearch.groupIds = data;
        },
        getForLevelVal(data) {
            this.formSearch.gradeIds = data;
        },
    },
}
</script>

<style scoped lang="scss">
.step-member {
    padding-bottom: 20px;
}

.form-member-query {
    padding: 5px 10px 10px 20px;
}

//20190131 全选所有人员
.member-tab {
    user-select: none;

    .check-btn {
        display: inline-block;
        margin-right: 5px;

        &:hover {
            transform: scale(1.05);
        }
    }
}
</style>
